"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransaction = void 0;
const chain_jslib_1 = require("@crypto-org-chain/chain-jslib");
const types_1 = require("@crypto-org-chain/chain-jslib/lib/dist/transaction/types");
const sdk_1 = require("./api/sdk");
const logic_1 = require("./logic");
const getTransactionAmount = (a, t) => {
    const croSdk = (0, logic_1.getCroSdk)(a.currency.id);
    switch (t.mode) {
        case "send":
            if (t.useAllAmount) {
                const balanceMinusFee = a.balance.minus(t.fees || 0);
                return new croSdk.Coin(balanceMinusFee.toString(), chain_jslib_1.Units.BASE);
            }
            else {
                return new croSdk.Coin(t.amount.toString(), chain_jslib_1.Units.BASE);
            }
        default:
            throw new Error("Unknown mode in transaction");
    }
};
/**
 *
 * @param {Account} a
 * @param {Transaction} t
 */
const buildTransaction = (a, t, publicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const croSdk = (0, logic_1.getCroSdk)(a.currency.id);
    const address = a.freshAddress;
    const { accountNumber, sequence } = yield (0, sdk_1.getAccountParams)(address, a.currency.id);
    const rawTx = new croSdk.RawTransaction();
    rawTx.setFee(new croSdk.Coin((t.fees || 0).toString(), chain_jslib_1.Units.BASE));
    const msgSend = new croSdk.bank.MsgSend({
        fromAddress: address,
        toAddress: t.recipient,
        amount: getTransactionAmount(a, t),
    });
    const { memo } = t;
    const memoTransaction = memo || "";
    rawTx.setMemo(memoTransaction);
    const signableTx = rawTx
        .appendMessage(msgSend)
        .addSigner({
        publicKey: chain_jslib_1.utils.Bytes.fromHexString(publicKey),
        accountNumber: new chain_jslib_1.utils.Big(accountNumber),
        accountSequence: new chain_jslib_1.utils.Big(sequence),
        signMode: types_1.SIGN_MODE.LEGACY_AMINO_JSON,
    })
        .toSignable();
    return signableTx;
});
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map